module.exports = __webpack_public_path__ + "static/media/volumeOne02.4f1f088d.jpg";